import React, { useEffect } from "react";
import dynamic from "next/dynamic";
import { subscribeEvent, unsubscribeEvent, mergeDeep } from "./helpers";
import { EVENTS, MODAL_CONFIG } from "./constants";
import useModal from "./hooks/useModal";

const PopupModal = dynamic(() => import("@/bit/components/components.popup-modal"));

function SamController() {
  const displayModal = useModal();

  const modalHandler = (event) => {
    const config = event?.detail?.config || {};
    const props = event?.detail?.props || null;

    displayModal({
      Component: PopupModal,
      props: props,
      config: {
        ...mergeDeep(config, MODAL_CONFIG),
        type: event.type,
      },
    });
  };

  useEffect(() => {
    subscribeEvent(EVENTS.MODAL, modalHandler);

    return () => {
      unsubscribeEvent(EVENTS.MODAL);
    };
  }, []);

  return <div id="sam_controller" />;
}

export default SamController;
